export default {
  history: 'Historie',
  version: 'Version',
};
